import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 0 16px;
  
  form {
    display: flex;

    .details-container {
      display: flex;
      flex-direction: column;
      gap: 18px;
      width: 669px;
      padding: 24px 16px 24px 0;

      .form-title {
        font-family: ManropeLight, sans-serif;
        font-size: 13px;
      }
    }

    .preview-container {
      width: 351px;
      padding: 24px 0 24px 16px;

      .preview-card {
        height: 496px;
        width: 100%;
        background: ${(props) => props.theme.colors.widget_background};
        border-radius: 12px;
        padding: 16px;

        .preview-card-title {
          width: 100%;
          height: 54px;
          text-align: center;
          font-size: 16px;
          line-height: 22px;
        }

        .preview-card-tags-container {
          height: 360px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          width: 100%;

          img {
            max-width: 100px;
            max-height: 100px;
            margin-bottom: 8px;
            border-radius: 12px;
          }

          .license {
            font-family: ManropeBold, sans-serif;
            font-size: 13px;
            margin-bottom: 4px;
            line-height: 18px;
          }

          .model {
            font-size: 13px;
            color: ${(props) => props.theme.colors.inactive};
            margin-bottom: 16px;
            line-height: 18px;
          }

          div {
            margin-bottom: 8px;
          }
        }

        .preview-card-buttons-container {
          display: flex;
          justify-content: center;
          gap: 16px;
          font-family: ManropeBold, sans-serif;
          font-size: 13px;

          button {
            width: 135px;
            padding: 16px 30px;
            justify-content: center;
          }

          .add-button {
            background-color: ${(props) => props.theme.colors.main_cta};
            color: ${(props) => props.theme.colors.widget_background};

            &:hover {
              background-color: ${(props) => props.theme.colors.widget_hover_background};
              color: ${(props) => props.theme.colors.main_cta};
            }

            &:disabled {
              cursor: default;
              background-color: ${(props) => props.theme.colors.inactive};
              color: ${(props) => props.theme.colors.black};
            }
          }
        }
      }
    }
  }
`;

const RowContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  gap: 16px;
`;

const ErrorMessage = styled.p`
  color: ${(props) => props.theme.colors.red};
  text-align: center;
  font-family: ManropeLight, sans-serif;
`;

export default { Wrapper, RowContainer, ErrorMessage };
